<p-panel styleClass="pt-3 p-panel-slimheight">
    <ng-template pTemplate="header">
        <div class="flex align-items-center">
            <span class="font-semibold">{{ 'COMMANDS' | translate }}</span>
        </div>
    </ng-template>
    <ng-template pTemplate="icons">
        <p-button icon="pi cm-pencil" pTooltip="{{ 'EDIT' | translate }}" tooltipPosition="bottom" (click)="editAlias()"
            [text]="true" severity="secondary" [disabled]="!deviceConfigured || !currentDevice.CurrentlyOwned">
        </p-button>
    </ng-template>
    <div class="grid">
        <div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl"
            *ngIf="!deviceConfiguredOnline()">
            <p-tag icon="pi cm-alert" [value]="('COMMANDS_NOT_AVAILABLE' | translate)" severity="warning"></p-tag>
        </div>
        <div class="col-12 flex align-items-center justify-content-center"
            [class]="underTablet() ? 'grid mx-1' : 'grid pt-4 pb-0'">
            <div *ngFor="let command of order(commands)" [class]="underTablet() ? 'col-12 pb-0' : 'col-3'">
                <button type="button" pButton pRipple id="buttonDeviceCommand-{{command.Description}}"
                    [disabled]="!deviceConfiguredOnline()" label="{{ command.Description }}"
                    class="p-button-{{getColor(command)}} text-xl font-normal" (click)="executeCommand(command.Id)">
                </button>
            </div>
            <div [class]="underTablet() ? 'col-12 pb-0' : 'col-6'"
                *ngIf="isRbe24230() && currentDevice.CurrentlyOwned && isTechnician">
                <button type="button" pButton pRipple [disabled]="scanConnectedAutomation || !deviceConfiguredOnline()"
                    label="{{ 'MANUAL_SCAN_AUTOMATION' | translate }}" class="p-button-warning text-xl font-normal"
                    (click)="manualScan()" icon="pi cm-reload" iconPos="left">
                </button>
            </div>
        </div>
    </div>
</p-panel>